import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { attorneysKeys } from 'app/queries/attorneys/attorneysKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof attorneysKeys.accessList>>;

export const createFetchAttorneyAccessesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getAttorneyAccessesList({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
        }),
        signal,
      ),
    );
